import { useEffect } from "react";
import PageContainer from "@components/layout/PageContainer";
import { useParams } from "react-router-dom";
import styles from "./style.module.scss";
import ProviderOrderForm from "@components/forms/ProviderOrderForm";
import AddProductToDocumentOffCanvas from "@components/layout/Offcanvas/AddProductToDocumentOffCanvas";
import { LoadInvoiceTemplatePubSub } from "@utils/pubsubs/PubSub";
import { InvoiceTemplateDataType } from "@/api/InvoiceTemplateApi";

type ProviderOrderAddEditProps = {
  copyData?: boolean
}

const ProviderOrderAddEdit = (props: ProviderOrderAddEditProps) => {
  const { copyData = false } = props
  const params = useParams()
  const { id: copyProviderOrderId } = params;

  useEffect(() => {
  }, []);

  const onTemplateSelect = (invoiceTemplate: InvoiceTemplateDataType) => {
    LoadInvoiceTemplatePubSub.publish({ invoiceTemplate })
  }

  const getPageTitle = () => {
    return "Agregar Orden de Compra"
  }

  return (
    <PageContainer
      containerClassName={styles.mainContainer}
      title={getPageTitle()}
      backUrl="/user/providerorders"
      primaryActions={[
        {
          actionTitle: "Guardar",
          formId: "providerOrderAdd",
          type: "submit",
          color: "success"
        },
        {
          customElement: (
            <AddProductToDocumentOffCanvas
              onTemplateSelect={onTemplateSelect}
              btnColor="success">
              <b>Agregar Producto</b>
            </AddProductToDocumentOffCanvas>
          )
        }
      ]}
    >
      <ProviderOrderForm
        id={copyProviderOrderId}
        copyData={copyData}
        saveRedirectUrl="/user/providerorders"
        formId="providerOrderAdd" >
      </ProviderOrderForm>
    </PageContainer>
  );
}

export default ProviderOrderAddEdit;
